import api from './axiosConfig';
import { handleApiError } from './errorHandler';

export const permissionsAPI = {
    /**
     * Get all available endpoint permissions
     */
    getAllPermissions: async () => {
        try {
            const { data } = await api.get('/api/permissions/all/');
            return data;
        } catch (error) {
            handleApiError(error, 'Get all permissions error:');
            throw error;
        }
    },

    /**
     * Get current user's permissions
     */
    getCurrentUserPermissions: async () => {
        try {
            const { data } = await api.get('/api/permissions/current/');
            return data;
        } catch (error) {
            handleApiError(error, 'Get current user permissions error:');
            throw error;
        }
    },

    /**
     * Get permissions for a specific user
     * @param {number} userId - The ID of the user
     */
    getUserPermissions: async (userId) => {
        try {
            const { data } = await api.get(`/api/permissions/user/${userId}/`);
            return data;
        } catch (error) {
            handleApiError(error, 'Get user permissions error:');
            throw error;
        }
    },

    /**
     * Grant permissions to a user
     * @param {number} userId - The ID of the user
     * @param {string[]} permissionCodes - Array of permission codes to grant
     * @param {string} notes - Optional notes about why permissions are being granted
     */
    grantPermissions: async (userId, permissionCodes, notes = '') => {
        try {
            const { data } = await api.post(
                `/api/permissions/user/${userId}/grant/`,
                {
                    permission_codes: permissionCodes,
                    notes: notes
                }
            );
            return data;
        } catch (error) {
            handleApiError(error, 'Grant permissions error:');
            throw error;
        }
    },

    /**
     * Revoke permissions from a user
     * @param {number} userId - The ID of the user
     * @param {string[]} permissionCodes - Array of permission codes to revoke
     */
    revokePermissions: async (userId, permissionCodes) => {
        try {
            const { data } = await api.post(
                `/api/permissions/user/${userId}/revoke/`,
                {
                    permission_codes: permissionCodes
                }
            );
            return data;
        } catch (error) {
            handleApiError(error, 'Revoke permissions error:');
            throw error;
        }
    }
};
